<template>
  <div>
    <template v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <!-- <p style="display: flex; align-items: center; gap: 5px">
              <span style="font-size: 14px; font-weight: 500">Filtri</span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                width="18"
              >
                <path
                  d="M960 682.7H527.3c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h134c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112s127.6-47.8 144-112c2.4-9.4 10.9-16 20.7-16h432.7c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3zm-597.3 128c-58.9 0-106.6-47.8-106.6-106.7s47.7-106.6 106.6-106.6 106.6 47.8 106.6 106.7-47.7 106.6-106.6 106.6zm298.6-341.4c69.4 0 127.6-47.8 144-112 2.4-9.4 10.9-16 20.7-16h134c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3H826c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h432.7c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112h0zm0-256c58.9 0 106.7 47.8 106.7 106.7s-47.8 106.7-106.7 106.7S554.6 378.9 554.6 320s47.8-106.7 106.7-106.7h0z"
                ></path>
              </svg>
            </p> -->
            <!-- <pre>{{ activeFilters }}</pre> -->
            <!-- v-for="(value, name, index) in computeActiveFilters" -->
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in activeFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span tabindex="0">
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countActiveFilters">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countActiveFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle:sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countActiveFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">
            {{ computedFilterTitle }}
          </span>
        </b-button-group>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            // {
            //   code: 'LISPOL',
            //   label: null,
            //   formats: ['csv', 'pdf'],
            // },
            {
              code: 'EXPOINPO',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
        <b-button
          class="btn btn--smaller btn--transparent"
          type="button"
          variant="secondary"
          size="sm"
          @click="customOpenManualNoteModal($event.target)"
          title="Visualizza polizze con note manuali"
          >Gestisci note con ereditarietà manuale
        </b-button>
        <b-button
          class="btn btn--create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="onAdd"
          title="Crea una nuova polizza"
          v-if="canVerb(resource, 'store')"
        >
          <base-icon name="circled_plus" width="22" height="22" />
          <span>Crea</span>
        </b-button>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <template #header="{ hide }">
            <div class="inner-header">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea una nuova polizza </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea una nuova polizza"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </div>
          </template>
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item" data-cols="3">
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="number"
                  type="text"
                  label="Numero"
                  v-model="filter.byAttribute.number"
                  placeholder="Inserisci un numero polizza"
                />
                <base-select
                  name="Frazionamento"
                  label="Frazionamento"
                  :options="payment_splitting"
                  v-model="filter.byAttribute.payment_splitting"
                />
                <base-input
                  :class="{
                    'filter-item-inner-wrapped': true,
                  }"
                  name="number"
                  type="text"
                  label="Targa"
                  v-model="filter.byAttribute.REPL"
                  placeholder="Inserisci una targa"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="Tipologia"
                  label="Tipologia"
                  :options="typologies"
                  v-model="filter.byTypology.status_policy"
                  @select="onTypologySelect"
                />
                <base-select
                  name="Status Polizza"
                  label="Status Polizza"
                  :options="status_policy"
                  v-model="filter.byAttribute.status_policy"
                  @select="onStatusSelect"
                />
              </div>
              <div class="filter-item" data-cols="2" data-select-all>
                <div>
                  <base-select
                    name="companies"
                    label="Compagnia"
                    :options="companies"
                    v-model="filter.byInsurer.id"
                    :multiple="true"
                    :taggable="true"
                    :closeOnSelect="false"
                    @input="onInputInsurer"
                  />
                  <b-button
                    :pressed.sync="myToggleC"
                    class="mt-3 btn btn--x-smaller btn--smaller btn--transparent"
                    @click="
                      myToggleC ? selectAllCompanies() : deselectAllCompanies()
                    "
                    >{{ myToggleC ? "Deseleziona tutte" : "Seleziona tutte" }}
                  </b-button>
                </div>
                <div>
                  <base-select
                    name="salesmen"
                    label="Produttori"
                    :options="salesmen_select"
                    :multiple="true"
                    :taggable="salesmen_taggable"
                    :closeOnSelect="false"
                    v-model="filter.byBroker.id"
                    :defaultHtmlMultipleSelect="true"
                    @changeTaggable="changeTaggable"
                  >
                    <template #advanced-actions>
                      <b-button
                        :pressed.sync="myToggle"
                        variant="light"
                        class="btn--x-smaller btn--smaller btn--transparent"
                        @click="
                          myToggle ? selectAllSalesmen() : deselectAllSalesmen()
                        "
                        >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                      </b-button>
                      <b-button
                        :pressed.sync="myTogglePO"
                        variant="light"
                        class="btn--smaller btn--x-smaller btn--transparent"
                        @click="
                          myTogglePO
                            ? salesmenOrderByCode()
                            : salesmenOrderByName()
                        "
                        >{{
                          myTogglePO ? "Ordine per nome" : "Ordina per codice"
                        }}
                      </b-button>
                    </template>
                  </base-select>
                </div>
              </div>
              <div class="filter-item" data-cols="3">
                <div>
                  <base-select
                    name="risks"
                    label="Tipo"
                    :options="risks"
                    v-model="filter.byRiskType.id"
                    :taggable="true"
                    :multiple="true"
                    :closeOnSelect="false"
                    @input="onInputRisk"
                  />
                  <!-- <b-button
                  type="button"
                  variant="light"
                  size="sm"
                  @click="selectAllRisks()"
                  >Seleziona tutti</b-button
                >

                <b-button
                  type="button"
                  variant="light"
                  size="sm"
                  @click="deselectAllRisks()"
                  >Deseleziona tutti</b-button
                > -->
                  <b-button
                    :pressed.sync="myToggleR"
                    class="mt-3 btn btn--x-smaller btn--smaller btn--transparent"
                    @click="myToggleR ? selectAllRisks() : deselectAllRisks()"
                    >{{ myToggleR ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                </div>
                <div>
                  <base-select
                    name="risk_branches"
                    :label="getDictionary('risk_branch_id', 'insurance_risk')"
                    :options="risk_branches"
                    v-model="filter.byRiskBranch.id"
                    :multiple="true"
                    :taggable="true"
                    :closeOnSelect="false"
                    @input="onInputBranch"
                  />

                  <!-- <b-button
                  type="button"
                  variant="light"
                  size="sm"
                  @click="selectAllBranches()"
                  >Seleziona tutti</b-button
                >

                <b-button
                  type="button"
                  variant="light"
                  size="sm"
                  @click="deselectAllBranches()"
                  >Deseleziona tutti</b-button
                > -->
                  <b-button
                    :pressed.sync="myToggleB"
                    class="mt-3 btn btn--x-smaller btn--smaller btn--transparent"
                    @click="
                      myToggleB ? selectAllBranches() : deselectAllBranches()
                    "
                    >{{ myToggleB ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                </div>
                <div>
                  <base-select
                    name="prdct"
                    label="Prodotto"
                    :options="prdct"
                    v-model="filter.byInsuranceRisk.id"
                    :taggable="true"
                    :multiple="true"
                    :closeOnSelect="false"
                  />
                  <!-- <b-button
                  type="button"
                  variant="light"
                  size="sm"
                  @click="selectAllProducts()"
                  >Seleziona tutti</b-button
                >

                <b-button
                  type="button"
                  variant="light"
                  size="sm"
                  @click="deselectAllProducts()"
                  >Deseleziona tutti</b-button
                > -->
                  <b-button
                    :pressed.sync="myToggleP"
                    class="mt-3 btn btn--x-smaller btn--smaller btn--transparent"
                    @click="
                      myToggleP ? selectAllProducts() : deselectAllProducts()
                    "
                    >{{ myToggleP ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                </div>
              </div>
              <div class="filter-item">
                <base-input
                  name="product_description"
                  type="text"
                  label="Descrizione Prodotto"
                  v-model="filter.byCustom.title.value"
                  placeholder="Inserisci la descrizione del Prodotto"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="expired_at"
                  label="Data Scadenza dal"
                  v-model="filter.byExpiration.from"
                />
                <base-datepicker
                  name="expired_at"
                  label="Data Scadenza al"
                  v-model="filter.byExpiration.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="covered_at"
                  label="Data Copertura dal"
                  v-model="filter.byCoverage.from"
                />
                <base-datepicker
                  name="covered_at"
                  label="Data Copertura al"
                  v-model="filter.byCoverage.to"
                />
              </div>
              <!-- <b-button-group
                v-b-toggle:collapse-1-inner
                class="my-2 filter-button-group"
              >
            <span class="when-open">
              <b-icon icon="funnel" font-scale="1.5"></b-icon>
            </span>
                <span class="when-closed">
              <b-icon icon="funnel" font-scale="1.5"></b-icon>
            </span>
                Altri Filtri
              </b-button-group> -->
              <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
              <div class="filter-item" data-type="registry-group">
                <div>
                  <b-button-toolbar>
                    <b-button-group>
                      <base-input
                        :class="{
                          'filter-item-inner-wrapped': true,
                        }"
                        name="Gruppo Anagrafico"
                        label="Gruppo Anagrafico"
                        v-model="form.inpt_label_group"
                        :readonly="true"
                      />
                      <b-button
                        class="btn-quick btn--light"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        title="Cerca gruppo anagrafico"
                        @click="openQuickSearchGroup"
                      >
                        <base-icon
                          name="search"
                          width="14"
                          height="14"
                        ></base-icon>
                      </b-button>
                      <b-button
                        v-if="form.inpt_label_group"
                        class="btn--light btn--alert"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        @click="resetGroupId"
                        title="Elimina gruppo anagrafico"
                      >
                        <base-icon
                          name="trash"
                          width="22"
                          height="22"
                        ></base-icon>
                      </b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </div>
              <quick-search-group-modal
                ref="quickSearchGroup"
                @input="handleGroupModalInput"
              ></quick-search-group-modal>
              <div class="filter-item" data-type="registry-group-info">
                <div class="details-card-wrapper" v-if="extra_group_full_info">
                  <b-card>
                    <div
                      slot="header"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 d-inline-block align-middle">
                        <strong
                          >Informazioni gruppo anagrafico selezionato</strong
                        >
                      </p>
                    </div>
                    <div
                      class="custom-grid-wrapper"
                      v-html="extra_group_full_info"
                    ></div>
                  </b-card>
                </div>
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="cooperators"
                  label="Collaborazioni"
                  :options="cooperators"
                  :multiple="true"
                  :taggable="true"
                  v-model="filter.byCollaborator.id"
                />
                <!-- v-model="filter.byBrokerEnhanced.cooperators" -->
                <!-- <base-input
                  name="mandate_code"
                  type="text"
                  label="Codice Mandato"
                  v-model="filter.byAttribute.mandate_code"
                  placeholder="Inserisci un codice mandato"
                /> -->
                <base-select
                  name="mandate_code"
                  label="Codice Mandato"
                  :options="mandate_code_options"
                  v-model="filter.byAttribute.mandate_code_id"
                  placeholder="Seleziona un codice mandato"
                />
                <!-- :disabled="!filter.byInsurer.id" -->
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="effective_at"
                  label="Data Decorrenza dal"
                  v-model="filter.byValidity.from"
                />
                <base-datepicker
                  name="effective_at"
                  label="Data Decorrenza al"
                  v-model="filter.byValidity.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="issued_at"
                  label="Data Emissione dal"
                  v-model="filter.byIssue.from"
                />
                <base-datepicker
                  name="issued_at"
                  label="Data Emissione al"
                  v-model="filter.byIssue.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="suspended_at"
                  label="Data sospensione dal"
                  v-model="filter.bySuspension.from"
                />
                <base-datepicker
                  name="suspended_at"
                  label="Data sospensione al"
                  v-model="filter.bySuspension.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="cancelled_at"
                  label="Data storno dal"
                  v-model="filter.byCancellation.from"
                />
                <base-datepicker
                  name="cancelled_at"
                  label="Data storno al"
                  v-model="filter.byCancellation.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-select
                  name="companies"
                  label="Polizze soggette a regolazione premio"
                  :options="bona"
                  v-model="filter.byAttribute.BONA"
                />
                <base-select
                  name="companies"
                  label="Polizze indicizzate"
                  :options="indx"
                  v-model="filter.byAttribute.INDX"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="note"
                  label="Note"
                  v-model="filter.byTask.task_type"
                  :options="policies_with_notes"
                  :taggable="false"
                  :multiple="false"
                  :closeOnSelect="true"
                />
              </div>
              <div class="mt-5" v-show="customFilters.length > 0">
                <h3 class="inner-filter-title">
                  Filtri sui "Campi Aggiuntivi"
                </h3>
                <custom-filter
                  v-for="(element, index) in customFilters.filter(
                    (e) => getInputType(e) === 'text',
                  )"
                  :key="`A${index}`"
                  v-model="filter.byCustom[element.key]['value']"
                  :element="element"
                />
                <custom-filter
                  v-for="(element, index) in customFilters.filter(
                    (e) => getInputType(e) !== 'text',
                  )"
                  :key="`B${index}`"
                  v-model="filter.byAttribute[element.key]"
                  :element="element"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca
              </b-button>
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
                >Reset
              </b-button>
            </div>
          </b-form>
        </b-sidebar>
        <b-modal
          :dialog-class="customModalClass"
          :id="customModalName"
          :title="customModalTitle"
          :size="customModalSize"
          scrollable
          ok-only
          ok-title="Chiudi"
          ok-variant="-transparent"
          header-bg-variant="lisaweb"
          no-close-on-backdrop
        >
          <template v-slot:modal-header-close>
            <base-icon name="close" width="14" height="14" />
          </template>
          <div>
            <b-tabs content-class="pt-1" lazy v-model="tabIndex">
              <b-tab
                v-for="(tab, index) in tabs"
                :key="index"
                @click="customSetTab(tab, index)"
                :title="tab.text"
                :active="index === tabIndex"
                title-item-class="lisaweb"
              >
                <component :is="selected"></component>
              </b-tab>
            </b-tabs>
          </div>
        </b-modal>
        <table-policies
          @edit="onEdit"
          @destroy="onDestroy"
          @manualFetch="manualFetch"
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :performedSearch="computePerformedSearch"
          :filterCount="countActiveFilters"
          :filterOn="{
            byRelations: [
              'byInsurer',
              'byInsuranceRisk',
              'byRegistryGroup',
              'byTask',
              'byDocument',
              'byBroker',
              'byCollaborator',
            ],
          }"
          :filterName="filterName"
          :ref="tableRef"
          :onlyActions="['edit', 'destroy', 'infomodal', 'edit_broker']"
        >
        </table-policies>
      </div>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import TablePolicies from "@/components/tables/Policies";
import BaseInput from "@/components/form/BaseInput";
// import ButtonGroupTable from "@/components/ButtonGroupTable";
import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import CustomFilter from "@/components/form/CustomFilter";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import ManualNotes from "@/components/wallet/policies/details/ManualNotes";
// import ExportsMixin from "@/mixins/ExportsMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData } from "@/utils/transforms";
import { getInputType } from "@/utils/forms";
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import BaseIcon from "@/components/BaseIcon";
import { computed } from "vue";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      customModalClass: "modal-note-manuali",
      customModalName: "modalNoteManuali",
      customModalTitle: "Polizze sostituite con note ad ereditarietà manuale",
      customModalSize: "xl",
      tabs: [{ name: "ManualNotes", text: "Note Manuali" }],
      activeFilters: {},
      isLoading: true,
      exportUrl: null,
      myToggleB: false,
      myToggleC: false,
      myToggleP: false,
      myToggleR: false,
      myTogglePO: false,
      myToggle: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      filter: this.initFilter(),
      filterName: "filterPolicy",
      repository: "insurance_policy",
      resource: "insurance_policies",
      context: "insurance_policies",
      tableRef: "PolicyTableRef",
      performedSearch: false,
      notes: [],
      documents: [],
      companies: [],
      risk_branches: [],
      risk_branches_tot_length: null,
      mandate_code_options: [],
      risks: [],
      policies_with_notes: [
        { value: "2", text: "Cerca solo polizze con note" },
      ],
      indx: [{ value: "Y", text: "Si" }],
      bona: [{ value: "Y", text: "Si" }],
      products: [],
      salesmen: [],
      salesmen_taggable: true,
      cooperators: [],
      fields: [
        {
          key: "insurer.title",
          value: "insurer.title",
          label: this.getDictionary("title", "insurer"),
          sortable: true,
          sortKey: "byInsurer.title",
        },
        {
          key: "number",
          value: "number",
          label: this.getDictionary("number", "insurance_policy"),
          sortable: true,
          sortkey: "byAttribute.number",
        },
        {
          key: "collaborator",
          value: (item) => toInfoData(item.collaborator, "broker"),
          label: this.getDictionary("Polizza in collaborazione"),
        },
        {
          key: "effective_at",
          label: this.getDictionary("effective_at", "insurance_policy"),
          value: "effective_at",
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          sortKey: "effective_at",
        },
        {
          key: "covered_at",
          label: this.getDictionary("covered_at", "insurance_policy"),
          value: "covered_at",
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          sortKey: "covered_at",
        },
        {
          key: "expired_at",
          label: this.getDictionary("expired_at", "insurance_policy"),
          value: "expired_at",
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          sortKey: "expired_at",
        },
        {
          key: "suspended_at",
          label: this.getDictionary("suspended_at", "insurance_policy"),
          value: (value) => toLocaleDate(value, "DD/MM/YYYY", "00/00/0000"),
          formatter: (value) => toLocaleDate(value, "DD/MM/YYYY", "00/00/0000"),
          sortable: true,
          sortKey: "suspended_at",
        },
        {
          key: "gross_premium",
          label: this.getDictionary("gross_premium", "insurance_policy"),
          value: (value) => toLocaleCurrency(value),
          formatter: (value) => toLocaleCurrency(value),
          sortable: true,
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "gross_payment_splitting",
          value: (item) =>
            toLocaleCurrency(
              item.gross_premium *
                (12 / (parseInt(item.payment_splitting.value) || 12)),
            ),
          label: this.getDictionary("total_gross", "insurance_policy"),
          sortable: true,
          sortKey: "byAttribute.gross_premium",
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "payment_splitting.text",
          value: "payment_splitting.text",
          label: this.getDictionary("payment_splitting", "insurance_policy"),
          sortable: true,
          sortKey: "installments",
        },
        {
          // Ramo
          key: "insurance_risk.risk_branch.title",
          value: "insurance_risk.risk_branch.title",
          label: this.getDictionary("risk_branch_id", "insurance_risk"),
          sortable: true,
          sortKey: "byRiskBranch.code",
        },
        {
          // Prodotto
          key: "insurance_risk",
          value: "insurance_risk.title",
          label: this.getDictionary("insurance_risk"),
          sortable: true,
          sortKey: "byInsuranceRisk.code",
        },
        {
          key: "status_policy.text",
          value: "status_policy.text",
          label: this.getDictionary("status_policy", "insurance_policy"),
          sortable: true,
          sortKey: "byAttribute.status_policy",
        },
        {
          key: "contraente",
          value: (item) =>
            item.registry ? toInfoData(item.registry, "registryfullname") : "",
          label: this.getDictionary("contractor"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "primary_group",
          value: (item) =>
            item.registry
              ? item.registry.registry_groups.length &&
                item.registry.registry_groups.find(
                  (registry_group) =>
                    registry_group.pivot.primary.value === "Y",
                )
                ? item.registry.registry_groups.find(
                    (registry_group) =>
                      registry_group.pivot.primary.value === "Y",
                  ).code
                : ""
              : "",
          label: this.getDictionary("Gruppo Primario del contraente"),
        },
        {
          key: "broker",
          label: this.getDictionary("salesman"),
          sortable: true,
          sortKey: "byBroker.BUID",
          value: (item) => toInfoData(item.broker, "broker"),
        },
        {
          key: "delay_days",
          label: this.getDictionary("delay_days", "insurance_policy"),
          value: (item) =>
            item.delay_days ? item.delay_days : item.insurance_risk.delay_days,
          sortable: false,
        },
        {
          key: "mandate_code_id",
          label: this.getDictionary("mandate_code", "insurance_policy"),
          formatter: (value) =>
            this.getMandateCodes()().find((m) => m.value === value)?.code ??
            value,
          sortable: true,
          sortKey: "byAttribute.mandate_code_id",
        },
        {
          key: "document_counter",
          label: this.getDictionary("Documenti"),
          value: (item) => (item.documents.length ? item.documents.length : 0),
        },
        {
          key: "note_counter",
          label: this.getDictionary("Note"),
          value: (item) =>
            item.tasks.length
              ? item.tasks.filter((task) => task.task_type.value === 2).length
              : 0,
        },
      ],
      payment_splitting: [
        { value: "0", text: "Unico" },
        { value: "1", text: "Mensile" },
        { value: "2", text: "Bimestrale" },
        { value: "3", text: "Trimestrale" },
        { value: "4", text: "Quadrimestrale" },
        { value: "6", text: "Semestrale" },
        { value: "12", text: "Annuale" },
      ],
      status_policy: [
        { value: "0", text: "Non perfezionata" },
        { value: "1", text: "Perfezionata" },
        { value: "2", text: "Sospesa" },
        { value: "3", text: "Sostituita" },
        { value: "10", text: "Stornata" },
        { value: "4", text: "Annullata" },
        { value: "5", text: "Scaduta" },
        { value: "6", text: "Svincolata" },
        { value: "7", text: "Abbandonata" },
        { value: "8", text: "Disdetta" },
        { value: "9", text: "Nuova viva" },
        { value: "11", text: "Trasferita" },
      ],
      typologies: [
        { value: "0,1,2", text: "Polizze attive" },
        { value: "3,4,5,6,7,8,9,10,11", text: "Polizze estinte" },
      ],
      group_data: null,
      extra_group_full_info: null,
      form: {
        inpt_label_group: "",
        quick_value: "",
      },
      selected: "ManualNotes", // dynamically load selected component in tabs
      modalResourceId: null, // prop for the dynamic components
      tabIndex: 0, // remember last visited tab: set active tab when modal gets opened
      dbRowData: null, // used to pass the actual record to tabs
    };
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      args: computed(() => this.args),
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    CustomFilter,
    TablePolicies,
    BaseDatepicker,
    // ButtonGroupTable,
    ExportOptions,
    QuickSearchGroupModal,
    ManualNotes,
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    // The saved filter stores the "Tipologia" selection under byAttribute.status_policy
    // (onSearch transforms byTypology -> byAttribute for the API). The mixin hydrates that
    // saved value straight back into this.filter, leaving a typology value (e.g. "0,1,2")
    // in the "Status Polizza" select, which has no such option. Reverse it on load so the
    // Tipologia select and the chip reflect the user's actual choice.
    const sp = this.filter?.byAttribute?.status_policy;
    if (sp != null && this.typologies.some((t) => t.value === sp)) {
      this.filter.byTypology.status_policy = sp;
      this.filter.byAttribute.status_policy = null;
    }
  },
  mounted() {
    this.companies = this.getInsurers();
    this.risk_branches = this.getBranches()(this.filter.byInsurer.id);
    this.risk_branches_tot_length = this.risk_branches.length;
    this.risks = this.getRisks();
    this.salesmen = this.getSalesmen();
    this.activeFilters = {};
    this.activeFilters = this.retriveActiveFilters();
    // const shouldOpenSidebar = this.areActiveFiltersOnlyDefault();
    // console.log("shouldOpenSidebar", shouldOpenSidebar);
    // this.open_filter = this.countActiveFilters ? false : true;
    // this.open_filter = this.areActiveFiltersOnlyDefault();
    // this.cooperators = this.getCooperators();
    // this.mandate_code_options = this.getMandateCodes()(null);
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    this.isLoading = true;
    if (!this.hasLoadedResource("countries"))
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("councils"))
      // this.getResources("auth/councils");
      // resources.push({
      //   path: path,
      //   value: "councils",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("provinces"))
      // this.getResources("auth/provinces");
      // resources.push({
      //   path: path,
      //   value: "provinces",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("cooperators")) {
      resources.push(
        this.$store
          .dispatch(`${path}cooperators`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.cooperators = this.getCooperators();
    }
    if (!this.hasLoadedResource("mandate_codes")) {
      resources.push(
        this.$store
          .dispatch(`${path}mandate_codes`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.mandate_code_options = this.getMandateCodes()(null);
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.cooperators = this.getCooperators();
          this.mandate_code_options = this.getMandateCodes()(null);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.unloadMsg();
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
    // const defaultCountryId = this.getCountries().find(
    //   (country) => country.text == this.defaultCountryName
    // ).value;
    // this.opt_provinces = this.getProvinces()(defaultCountryId);
  },
  methods: {
    toInfoData,
    getInputType,
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    customSetTab(tab, index) {
      console.log("select tab: ", tab.name);
      this.customSelTab = tab.name;
      this.tabIndex = index;
    },
    customOpenManualNoteModal(target) {
      this.$bvModal.show(this.customModalName, target);
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    initFilter() {
      let init = {
        byAttribute: {
          number: null,
          mandate_code_id: null,
          payment_splitting: null,
          status_policy: null,
          covered_at: null,
          effective_at: null,
          expired_at: null,
          issued_at: null,
          REPL: null,
          BONA: null,
          INDX: null,
        },
        byCustom: {
          title: {
            value: null,
            likewise: 3,
            filter: "byAttribute",
          },
        },
        byCoverage: {
          to: null,
          from: null,
        },
        byExpiration: {
          to: null,
          from: null,
        },
        // byBrokerEnhanced: {
        //   salesmen: [],
        //   cooperators: [],
        // },
        byBroker: {
          id: null,
        },
        byCollaborator: {
          id: null,
        },
        byRegistryGroup: {
          code: null,
          byBroker: {
            id: null,
          },
        },
        byTask: {
          task_type: null,
        },
        byIssue: {
          to: null,
          from: null,
        },
        byValidity: {
          to: null,
          from: null,
        },
        bySuspension: {
          to: null,
          from: null,
        },
        byCancellation: {
          to: null,
          from: null,
        },
        byInsurer: {
          id: [],
        },
        byInsuranceRisk: {
          id: null,
        },
        byRiskBranch: {
          id: null,
        },
        byRiskType: {
          id: null,
        },
        byTypology: {
          status_policy: "0,1,2",
        },
      };
      return init;
    },
    onInputInsurer(insurer) {
      // insurer è un array
      this.filter.byInsurer.id = insurer;
      this.filter.byRiskBranch.id = null;
      if (
        insurer?.length &&
        this.risk_branches_tot_length !== this.risk_branches.length
      ) {
        let full_risk_branches = [];
        insurer.forEach((el) => {
          full_risk_branches = [
            ...full_risk_branches,
            ...this.getBranches()(el),
          ];
        });
        this.risk_branches = [
          ...new Set(full_risk_branches.map(JSON.stringify)),
        ].map(JSON.parse);
      } else {
        this.risk_branches = insurer.length
          ? this.getBranches()(insurer)
          : this.getBranches()();
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
      // reset mandate_code_id
      this.filter.byAttribute.mandate_code_id = null;
      // carica (o svuota) la tendina dei mandati
      this.mandate_code_options = [];
      this.mandate_code_options = this.getMandateCodes()(insurer);
    },
    deselectAllBranches() {
      this.filter.byRiskBranch.id = [];
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
    },
    deselectAllCompanies() {
      this.filter.byInsurer.id = [];
      this.filter.byRiskType.id = [];
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
      this.renderAllBranches();
    },
    deselectAllRisks() {
      this.filter.byRiskType.id = [];
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
    },
    deselectAllProducts() {
      this.filter.byInsuranceRisk.id = [];
    },
    selectAllBranches() {
      this.filter.byRiskBranch.id = this.risk_branches.map(
        (branch) => branch.value,
      );
    },
    selectAllRisks() {
      this.filter.byRiskType.id = this.risks.map((risk) => risk.value);
    },
    selectAllCompanies() {
      this.filter.byInsurer.id = this.companies.map((company) => company.value);
      this.renderAllBranches();
    },
    renderAllBranches() {
      if (this.filter.byInsurer.id.length === 0) return;
      this.risk_branches = this.getBranches()();
    },
    selectAllProducts() {
      this.filter.byInsuranceRisk.id = this.products.map(
        (product) => product.value,
      );
    },
    onInputBranch(branches) {
      if (!branches.length) {
        this.filter.byRiskBranch.id = null;
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        branches,
        this.filter.byRiskType.id,
      );
    },
    onInputRisk(risks) {
      if (!risks.length) {
        this.filter.byRiskType.id = null;
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        risks,
      );
    },
    onStatusSelect(val) {
      if (val) this.filter.byTypology.status_policy = null;
    },
    onTypologySelect(val) {
      if (val) this.filter.byAttribute.status_policy = null;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id, item) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}`, item: item },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Polizza Eliminata con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSearch(name) {
      this.performedSearch = true;
      /* */
      // this.activeFilters = this.computeActiveFilters;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // preparo il criterio col filtro fittizio
      // process the byTypology filter -> transform it as byAttribute
      let byA = this.filter.byAttribute.status_policy;
      let byT = this.filter.byTypology.status_policy;
      // NOTA: per spezzare la reattività del "filter" usare JSON.parse(JSON.stringify()) !!!
      // altrimenti criteria.byAttribute.status_policy = byT imposta anche this.filter.byAttribute.status_policy = byT
      // e i v-model delle 2 select vanno a ramengo...
      let criteria = JSON.parse(JSON.stringify(this.filter));
      if (byT && !byA) {
        criteria.byAttribute.status_policy = byT;
        criteria.byTypology.status_policy = null;
      }
      // store the filter
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      /* */
      criteria = {};
      ["quickSearchGroup"].forEach((element) => {
        criteria[element] = {
          label: "",
          formLabel: "",
          data: null,
          formData: null,
        };
      });
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      /* */
      this.removePaginationByName(name);
      // fetch (data)
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetGroupId();
      this.myToggleR = false;
      this.myToggleB = false;
      this.myToggleP = false;
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeFilterExtraGroupByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
      removeFilterExtraGroupByName: "removeExtraGroupByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("filters", { loadFilterByName: "loadByName" }),
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getBranches: "branches",
      getRisks: "risks",
      getProducts: "products",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getCooperators: "cooperators",
      getMandateCodes: "mandate_codes",
    }),
  },
  computed: {
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    customSelTab: {
      set(value) {
        this.selected = value;
      },
      get() {
        return this.selected;
      },
    },
    prdct() {
      return this.products;
    },
  },
};
</script>
